interface MeasurementStepProps {
  number: number;
  text: string;
}

export const MeasurementStep = ({ number, text }: MeasurementStepProps) => {
  return (
    <div>
      <strong>{number}.</strong> {text}
    </div>
  );
};
